import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { CheckActive } from "routes/regime/plugins/publishing/register-publishing-step"

export function useCurrentStep(steps) {
    const context = useBoundContext()
    const active = CheckActive.call({ ...context, active: null })
    return [steps?.findIndex((i) => i.props?.id === active?.props?.id) ?? -1, active]
}
